import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/core/supabase/client';
import { useAuth } from '@/core/auth/useAuth';

export const CFA_OVERRIDE_KEY = 'cfa-override';

/**
 * Returns the current user's active CFA ID.
 * Priority: localStorage override > DB default (get_user_cfa_id RPC).
 * The override is set by the CFA switcher component.
 */
export function useCurrentCfaId(): string | null {
  const { session } = useAuth();

  const { data } = useQuery({
    queryKey: ['current-user-cfa', session?.user?.id],
    queryFn: async () => {
      // Check localStorage override first (set by CFA switcher)
      const override = localStorage.getItem(CFA_OVERRIDE_KEY);
      if (override) return override;

      // Default: use DB function (deterministic ORDER BY: admin > supervisor > operator)
      const { data, error } = await supabase.rpc('get_user_cfa_id');
      if (error) throw error;
      return data as string | null;
    },
    staleTime: Infinity,
    gcTime: 30 * 60 * 1000,
    enabled: !!session?.access_token,
  });

  return data ?? null;
}
